module.exports = __webpack_public_path__ + "images/49dc3e6e54b01c1959153802a6abdb6bc.svg";